import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './summary-section-header-content.module.css';
import { useEnablePremiumProgramTags } from '../../../../feature-flags/hooks/use-enable-premium-program-tags';
import { PremiumProgramTags } from '../../../premium-programs/premium-program-tags';

/**
 * @param {object} props
 * @param {string[]} props.premiumPrograms
 * @returns {JSX.Element}
 */
export const SummarySectionHeaderContent = ({ premiumPrograms = [] }) => {
  const isPremiumProgramTagsEnabled = useEnablePremiumProgramTags();

  return (
    <div className={style['header-content']}>
      <Text textType={TextType.H4} value={messages.summary} />
      {isPremiumProgramTagsEnabled && Boolean(premiumPrograms.length) ? (
        <div className={style['premium-programs']}>
          <PremiumProgramTags premiumPrograms={premiumPrograms} />
        </div>
      ) : null}
    </div>
  );
};
